import { lazy, Suspense } from "react";
import { useToast } from "@/hooks/use-toast";

const ToastPresentation = lazy(() =>
  import("@/components/ui/toaster").then((module) => ({ default: module.Toaster })),
);

/** La coda resta immediata; la presentazione Radix si carica al primo messaggio. */
export function DeferredToaster() {
  const { toasts } = useToast();
  if (toasts.length === 0) return null;
  return <Suspense fallback={null}><ToastPresentation /></Suspense>;
}
